// Actions
import {
  APP_SET_APPLICATION,
  APP_SET_THEME,
  APP_SET_UNIT_SYSTEM,
  APP_SET_LANGUAGE,
} from '../actionTypes';

/**
 * Sets the theme for the App
 * @param payload {string} The theme slug
 * @returns {function(*): Promise<null>}
 */
export const setAppTheme = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: APP_SET_THEME,
    payload,
  });
  resolve();
});

export const setUnitSystem = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: APP_SET_UNIT_SYSTEM,
    payload,
  });
  resolve();
});

export const setLanguage = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: APP_SET_LANGUAGE,
    payload,
  });
  resolve();
});

export const setApplication = (payload) => (dispatch) => new Promise((resolve) => {
  dispatch({
    type: APP_SET_APPLICATION,
    payload,
  });
  resolve();
});
